import { type FunctionComponent } from "react";
import { graphql, useFragment } from "react-relay";

import { checkHasLiveTag } from "~/components/article/article-render/helpers";
import type { contentLiveTagContent$key } from "~/queries/__generated__/contentLiveTagContent.graphql";

import { LiveTag } from "./styles";

type Props = {
  className?: string;
  hide?: boolean;
  reference: contentLiveTagContent$key;
};
export const ContentLiveTag: FunctionComponent<Props> = ({
  className,
  hide = false,
  reference,
}) => {
  const content = useFragment(
    graphql`
      fragment contentLiveTagContent on Article {
        ...helpersCheckHasLiveTagArticle
      }
    `,
    reference,
  );

  const hasLiveTag = checkHasLiveTag(content);

  return hasLiveTag ? (
    <LiveTag $hide={hide} className={className}>
      LIVE
    </LiveTag>
  ) : null;
};

ContentLiveTag.displayName = "ContentLiveTag";
